export const GetScheduleSendMailUsing365ListConst = "GetScheduleSendMailUsing365";
export const GetSentMailListConst="GetSentMailList"
export const GetMailTemplateListConst="GetMailTemplateList"
export const ReplyEmailPayload ="ReplyEmailPayload";
